export const actionsConst = {
    LOADED: 'ACTIONS_LOADED',
    UNLOADED: 'ACTIONS_UNLOADED',
    ADD: 'ADD_ACTION',
    PATCH: 'PATCH_ACTION',
    REMOVE: 'REMOVE_ACTION'
};
